import type { Particle, DistanceConstraint, Vec2 } from '@/types'
import { sub, scale, length, copy } from './vector'

export function createDistanceConstraint(
    indexA: number,
    indexB: number,
    restLength: number,
    stiffness: number = 1.0,
): DistanceConstraint {
    return { indexA, indexB, restLength, stiffness }
}

export function solveDistanceConstraints(
    particles: Particle[],
    constraints: DistanceConstraint[],
    iterations: number,
): void {
    for (let iter = 0; iter < iterations; iter++) {
        for (const c of constraints) {
            const a = particles[c.indexA]
            const b = particles[c.indexB]

            const delta = sub(b.position, a.position)
            const currentLength = length(delta)

            if (currentLength === 0) continue

            const difference = (currentLength - c.restLength) / currentLength
            const correction = scale(delta, 0.5 * difference * c.stiffness)

            if (!a.pinned) {
                a.position.x += correction.x
                a.position.y += correction.y
            }
            if (!b.pinned) {
                b.position.x -= correction.x
                b.position.y -= correction.y
            }
        }
    }
}

export function enforcePinConstraint(particle: Particle, anchor: Vec2): void {
    if (particle.pinned) {
        particle.position = copy(anchor)
        particle.previousPosition = copy(anchor)
    }
}
